import { SauceById } from "../modules";

export const SauceIdPage = () => {
  return <>
  <SauceById/>
  </>;
};
